(function () {
  function openDrawerIfExists() {
    // Versuch 1: Custom Element <cart-drawer> (Dawn-ähnlich)
    const cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.open === 'function') { cd.open(); return true; }

    // Versuch 2: klassischer Drawer Container
    const drawer = document.querySelector('#CartDrawer, .cart-drawer, .drawer');
    if (drawer) {
      drawer.classList.add('active', 'is-open', 'open');
      document.body.classList.add('overflow-hidden');
      return true;
    }
    return false;
  }

  async function ajaxAddToCart(form) {
    const fd = new FormData(form);

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!res.ok) throw new Error('ATC fehlgeschlagen: ' + res.status);
    await res.json();

    // Optional: Drawer öffnen (wenn vorhanden)
    openDrawerIfExists();

    // Optional: Bubble/Cart-Count refresh – viele Themes lauschen darauf
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  // Alle Produkt-ATC-Forms abfangen
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    // Shopify Product Form erkennt man i.d.R. so:
    const isProductForm =
      form.getAttribute('action') === '/cart/add' ||
      form.querySelector('input[name="id"]');

    if (!isProductForm) return;

    // Wichtig: Nur wenn wirklich der "Add" Submit ausgelöst wurde
    // (sonst könnte es auch ein anderes Form sein)
    const submitter = e.submitter;
    if (submitter && submitter.name && submitter.name !== 'add') {
      // manche Themes nutzen name="checkout" etc.
      return;
    }

    e.preventDefault();
    ajaxAddToCart(form).catch(console.error);
  }, true);
})();